function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.297 15.6C.598 15.6 0 15 0 14.3c0-.7.598-1.3 1.297-1.3C16.158 13 21.445 1.2 21.545 1c.299-.6.997-.9 1.695-.7.599.3.898 1 .698 1.7-.199.3-6.084 13.6-22.641 13.6z",
  fill: "#231F20",
  fillRule: "nonzero"
});

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 16,
    viewBox: "0 0 24 16"
  }, props), _ref);
};

export default SvgComponent;